import { render, staticRenderFns } from "./CategoryImg.vue?vue&type=template&id=5b90dec7&scoped=true&"
import script from "./CategoryImg.ts?vue&type=script&lang=ts&"
export * from "./CategoryImg.ts?vue&type=script&lang=ts&"
import style0 from "./CategoryImg.vue?vue&type=style&index=0&id=5b90dec7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b90dec7",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QImg,QCardActions});qInstall(component, 'directives', {Ripple});
